var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClear = function SvgClear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C2C4CC",
    fillRule: "evenodd",
    d: "M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12M3.883 9.026 6 6.909l2.117 2.117.909-.91L6.909 6l2.117-2.117-.91-.909L6 5.091 3.883 2.974l-.909.91L5.091 6 2.974 8.117z",
    clipRule: "evenodd"
  })));
};
export default SvgClear;